module.exports = {"pageTitleText":"Probes","createText":"Create","hostname":"HostName","serviceIP":"ServiceIP","description":"Description","status":"Status","sections":{"essential":"Essential"}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/probesetting.json
// module id = 53RR
// module chunks = 3